<div class="modal fade" id="dialogLicitacoesE" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header bg-banco-brasil">
        <span>Licitações-e | Banco do Brasil</span>
        <img src="assets/img/banco_brasil.jpg" alt="" title="" width="32" height="32">
      </div>
      <div class="modal-body">
        <div class="row text-muted">
          <div class="col-3">
            <label class="font-weight-bold">Nº Licitação:</label>
            <label class="ml-2">
              {{entidade?.numero | LICITACAO}}
            </label>
          </div>
          <div class="col-3">
            <label class="font-weight-bold">Nº Processo:</label>
            <label class="ml-2">
              {{entidade?.processo | LICITACAO}}
            </label>
          </div>
          <div class="col-6">
            <label class="font-weight-bold">Modalidade:</label>
            <label class="ml-2">
              {{entidade?.modalidade?.nome}}
            </label>
          </div>
        </div>
        <hr />
        <div class="row text-muted">
          <div class="col-12">
            <label>
              {{entidade?.objeto}}
            </label>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-link button-banco-brasil" (click)="exportarAOP711()">Exportar AOP711</button>
      </div>
    </div>
  </div>
</div>